import { StyleSheet, View, ViewProps } from "react-native";

import { useIsMobile } from "src/hooks/ui";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";

export const PdCard: React.FC<ViewProps & { variant?: "outline" | "solid" }> = ({
  variant = "outline",
  style,
  ...rest
}) => {
  const isMobile = useIsMobile();

  const dynamicStyles = variant === "solid" ? styles.bgGreen : [styles.border1, styles.borderGray];

  return (
    <View style={[dynamicStyles, isMobile ? [styles.px4, styles.py3] : [styles.px7, styles.py3], style]} {...rest} />
  );
};

const styles = StyleSheet.create({
  bgGreen: {
    backgroundColor: kColors.brandGreen,
  },
  border1: {
    borderWidth: 1,
  },
  borderGray: {
    borderColor: kColors.gray300,
  },
  px4: {
    paddingHorizontal: kStyleConst.kSpacing * 4,
  },
  px7: {
    paddingHorizontal: kStyleConst.kSpacing * 7,
  },
  py3: {
    paddingVertical: kStyleConst.kSpacing * 5,
  },
});
